export class RoleListModel {
  roleId?: number;
  roleName?: string = '';
  roleDesc?: string = '';
}
